// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductCarousel_ProductSlide_container","title":"ProductCarousel_ProductSlide_title","price":"ProductCarousel_ProductSlide_price"};